// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_VerificarRunResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/franquias/verificar/{id}
 * (controllers/migration/franquias.php::verificar).
 *
 * O RELATORIO do double-check deterministico da fase 6 — os quatro cheques,
 * cada um com nome, resultado e os numeros, mais os achados estruturados.
 *
 * ---------------------------------------------------------------------------
 * ESTE E O CONTRATO DA DECISAO 15
 * ---------------------------------------------------------------------------
 * "Migrar E verificar" e requisito de primeira classe, e ETAPA SEM VERIFICACAO
 * VERDE NAO CONTA COMO MIGRADA — mesmo com a fase 4 inteira verde. `verificado`
 * e o campo que transforma essa decisao em comportamento: false significa que a
 * carga rodou e a migracao NAO esta dada por boa, e `motivo` diz qual cheque
 * reprovou. A tela le os dois; nao ha um terceiro lugar onde consultar isso.
 *
 * `status_do_run` e lido do BANCO depois da verificacao, e nao derivado de
 * `verificado`: quem decide o status e o verificador (que nunca REBAIXA um run
 * — um `failed` continua `failed` mesmo com relatorio verde, e o motivo fica no
 * JSON). Derivar aqui criaria uma segunda opiniao sobre a mesma verdade, e ela
 * discordaria justamente no caso que mais importa.
 *
 * ---------------------------------------------------------------------------
 * O ESCOPO VEM ACHATADO
 * ---------------------------------------------------------------------------
 * O relatorio interno carrega `escopo: {tipo, zoho_id}`. No wire ele vira dois
 * campos irmaos porque sao dois escalares e um RowContract inteiro para
 * embrulha-los so acrescentaria um nivel de acesso na tela — sem nada a ganhar.
 * `escopo_zoho_id` e STRING pela armadilha A1 (19 digitos > 2^53).
 *
 * A public key do Zoho NAO aparece em nenhum campo deste contrato, por
 * construcao: ela vive so em `ZohoMigrationApi` (backend-only, decisao 21). E o
 * token fiscal tambem nao — os campos marcados `segredo` no de-para sao
 * comparados por PRESENCA dentro do verificador (ver Migration_VerificacaoAchadoRow).
 */
import type { Migration_VerificacaoCheckRow } from './Migration_VerificacaoCheckRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_VerificarRunResponseDados {
run_id: number
etapa: string
escopo_tipo: string
verificado: boolean
resumo: Record<string, number>
checks: Migration_VerificacaoCheckRow[]
status_do_run: string
gerado_em?: string
escopo_zoho_id?: string
motivo?: string
}

export type Migration_VerificarRunResponse = ApiResponse<Migration_VerificarRunResponseDados>;

registerResponseContract('Migration_VerificarRunResponse', {
  run_id:         { type: 'number',  required: true },
  etapa:          { type: 'string',  required: true },
  escopo_tipo:    { type: 'string',  required: true },
  verificado:     { type: 'boolean', required: true },
  resumo:         { type: 'object',  required: true },
  checks: {
    type: 'array',
    required: true,
    items: {
      nome:             { type: 'string',  required: false },
      titulo:           { type: 'string',  required: false },
      resultado:        { type: 'string',  required: false },
      numeros:          { type: 'object',  required: false },
      achados: {
        type: 'array',
        required: false,
        items: {
          codigo:     { type: 'string',  required: false },
          severidade: { type: 'string',  required: false },
          zoho_id:    { type: 'string',  required: false },
          detalhe:    { type: 'string',  required: false },
          origem:     { type: 'string',  required: false },
          destino:    { type: 'string',  required: false },
          esperado:   { type: 'string',  required: false },
          atual:      { type: 'string',  required: false },
          campo:      { type: 'string',  required: false },
        },
      },
      achados_omitidos: { type: 'number',  required: false },
      amostra:          { type: 'array',   required: false },
    },
  },
  status_do_run:  { type: 'string',  required: true },
  gerado_em:      { type: 'string',  required: false },
  escopo_zoho_id: { type: 'string',  required: false },
  motivo:         { type: 'string',  required: false },
})
